import React from "react";
import { FormattedMessage } from "react-intl";
import { MessageBanner } from "@folio/stripes/components";
import { API_PATHS } from "../../types/apiPaths";
import { AdminJobPanel } from "./AdminJobPanel";
var STAT_FIELDS = [
    {
        key: "overdueCount",
        labelId: "ui-br-legaldeposits.admin.overdue.stats.overdue",
    },
    {
        key: "remindersCreated",
        labelId: "ui-br-legaldeposits.admin.overdue.stats.reminders",
    },
    {
        key: "groupsSent",
        labelId: "ui-br-legaldeposits.admin.overdue.stats.groupsSent",
    },
    {
        key: "groupsFailed",
        labelId: "ui-br-legaldeposits.admin.overdue.stats.groupsFailed",
    },
    {
        key: "groupsPostponed",
        labelId: "ui-br-legaldeposits.admin.overdue.stats.groupsPostponed",
    },
    {
        key: "groupsPartiallyServed",
        labelId: "ui-br-legaldeposits.admin.overdue.stats.groupsPartiallyServed",
    },
    {
        key: "groupsNothingToSend",
        labelId: "ui-br-legaldeposits.admin.overdue.stats.groupsNothingToSend",
    },
];
var BANNER_TYPES = {
    SUCCESS: "success",
    PARTIAL: "warning",
    ERROR: "error",
    SKIPPED: "default",
};
var renderRunOutcome = function (status) {
    var _a, _b;
    var runStatus = status.runStatus;
    if (!runStatus)
        return null;
    var failures = (_a = status.failures) !== null && _a !== void 0 ? _a : [];
    return (React.createElement(MessageBanner, { type: (_b = BANNER_TYPES[runStatus]) !== null && _b !== void 0 ? _b : "default" },
        React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.admin.overdue.runStatus.".concat(runStatus) }),
        failures.length > 0 && (React.createElement("ul", null, failures.map(function (failure) { return (React.createElement("li", { key: failure }, failure)); })))));
};
export var OverdueDetection = function () { return (React.createElement(AdminJobPanel, { queryKey: "admin-overdue-status", statusPath: API_PATHS.LEGAL_DEPOSITS_ADMIN_DETECT_OVERDUE_STATUS, triggerPath: API_PATHS.LEGAL_DEPOSITS_ADMIN_DETECT_OVERDUE, i18nPrefix: "ui-br-legaldeposits.admin.overdue", statFields: STAT_FIELDS, resultBanner: renderRunOutcome })); };
